import { createApi } from '@reduxjs/toolkit/query/react'

import { baseApi } from './utils'
import { FleetManagementDashboard } from './types'

export const fleetManagementApi = createApi({
	reducerPath: 'fleetManagement',
	...baseApi('/fleet-management/'),
	endpoints: builder => ({
		getDashboard: builder.query<FleetManagementDashboard, void>({
			query: () => 'dashboard/',
		}),
	}),
})

export const { useGetDashboardQuery } = fleetManagementApi
